import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import Translate from '../../../../utils/Translate';
import Navigator from '../../../../utils/Navigator';
import './MainHeader.css';

const MainHeader = withRouter(props => (
  <div className="eva-3-row -no-gutter -eva-3-valign MainHeader">
    {
        props.name
        ? (
          <p className="-fs-md-7 -fs-sm-6">
            <span className="-eva-3-hide-small">
              <Link to={Navigator.profilePage}>
                <span className="eva-3-link -eva-3-tc-gray-3 -underline">{Translate.message('Mi perfil')}</span>
              </Link> <span className="-eva-3-tc-gray-0"> / </span>
            </span>
            <span className="-eva-3-tc-gray-0">
              {props.name}
            </span>
          </p>
        )
        : <p className="-fs-md-7 -fs-sm-6 -eva-3-tc-gray-0">{Translate.message('Mi Perfil')}</p>
      }
  </div>
));

MainHeader.defaultProps = {
  name: undefined,
};

MainHeader.propTypes = {
  name: PropTypes.string,
};

export default MainHeader;
